import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '01',
  title: 'Identificación',
  description: "Detectás los 'disparadores' que activan el pánico de tu perro antes de que salgas."
}, {
  number: '02',
  title: 'Desensibilización',
  description: 'Aplicás las micro-salidas de segundos para estirar su confianza sin romperla.'
}, {
  number: '03',
  title: 'Libertad',
  description: 'Graduás el tiempo de ausencia hasta que salir de casa sea un evento neutro para ambos.'
}];
export function HowItWorks() {
  return <section className="py-12 md:py-24 bg-charcoal text-white" data-id="element-130">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-131">
        <div className="text-center mb-10 md:mb-16" data-id="element-132">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-133">
            Cómo funciona <span className="text-amber-400" data-id="element-134">(En 3 pasos)</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-10 md:gap-8 relative" data-id="element-135">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-charcoal-light" data-id="element-136" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-137">
              <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-amber-500 flex items-center justify-center text-2xl md:text-3xl font-bold text-white mb-5 md:mb-8 shadow-lg shadow-amber-500/20 border-8 border-charcoal" data-id="element-138">
                {step.number}
              </div>
              <h3 className="text-2xl font-bold mb-4 text-cream-50" data-id="element-139">
                {step.title}
              </h3>
              <p className="text-cream-200 leading-relaxed max-w-sm" data-id="element-140">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}